<template>
  <div id="feedback">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.contact_customer_service')" placeholder safe-area-inset-top @click-left="onClickLeft" :right-text="$t('column.save_draft')" @click-right="onClickRight" left-arrow />
    <van-row>
      <van-col span="24" class="feedback_top">
        <van-notice-bar
            left-icon="info-o"
            :scrollable="true"
            :text="$t('column.choose_theright_category_response_speed')"
        />
      </van-col>
      <van-col span="22" offset="1">
        <van-col span="24" class="feedback_title"><span>*</span> {{ $t('column.please_select_category_question') }}</van-col>
        <van-col span="24">
          <van-row gutter="20">
            <van-col span="12">
              <van-col span="24" :class="type_i === 1 ? 'feedback_type_active feedback_type' : 'feedback_type'" @click.native="help_form_type_btn(1)"> {{ $t('column.consult')}} </van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" :class="type_i === 2 ? 'feedback_type_active feedback_type' : 'feedback_type'" @click.native="help_form_type_btn(2)">{{ $t('column.report_complaints')}}</van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" :class="type_i === 3 ? 'feedback_type_active feedback_type' : 'feedback_type'" @click.native="help_form_type_btn(3)">{{ $t('column.feedback') }}</van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" :class="type_i === 4 ? 'feedback_type_active feedback_type' : 'feedback_type'" @click.native="help_form_type_btn(4)">{{ $t('column.business_cooperation') }}</van-col>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="24" class="feedback_title"><span>*</span> {{ $t('column.please_describe_issue') }} </van-col>
        <van-col span="24">
          <van-field
              v-model="message"
              rows="4"
              autosize
              class="feedback_text"
              type="textarea"
              maxlength="500"
              :placeholder="$t('column.please_describe_problem_detail')"
              show-word-limit
          />
        </van-col>
        <van-col span="24">
          <!-- 上传图片 -->
          <van-col span="24">
            <uploadImage
                ref="uploader"
                class="help_form_upload"
                :imageUrl="proof_img"
                :cos-config="cosConfig"
                v-if="iscos"
                @successUploadImage="handleSuccess"
                @errorUploadImage="handleError"
            />
          </van-col>
        </van-col>
        <van-col span="24" class="feedback_title_text">{{ $t('column.please_provide_that_assist_problems')}}</van-col>
        <van-col span="22" offset="1">
          <van-button class="help_form_btn" color="#FF61F5" block round @click="onClickButton">{{ $t('column.submit') }}</van-button>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import UploadImage from "./upload_image.vue";
import axios from "axios";
import {Dialog} from "vant";

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      message: undefined,
      iscos: false,
      proof_img: undefined,
      type_i: 0,
      cosConfig: {
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      }
    }
  },
  created() {
    const list = localStorage.getItem('feedbackStorage');
    if (list) {
      const list_val = JSON.parse(list);
      this.message = list_val.message
      this.type_i = list_val.type_i
      this.proof_img = list_val.proof_img
      console.log('数据已从缓存中恢复');
    }
    this.getcosConfig()
  },
  methods: {
    onClickRight() {
      const list = {
        message: this.message,
        type_i: this.type_i,
        proof_img: this.proof_img
      }
      localStorage.setItem('feedbackStorage', JSON.stringify(list))
      Toast(this.$t('column.saved_successfully'))
    },
    help_form_type_btn(i) {
      this.type_i= i
    },
    onClickButton() {
      Dialog.confirm({
        title: this.$t('column.are_you_sure_to_submit'),
        confirmButtonColor: '#545AFF',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=add_feedback",{
          params:{
            uid: uid,
            token: token,
            message: this.message,
            type: this.type_i,
            proof_img: this.proof_img
          }
        }).then(res =>{
          localStorage.removeItem('feedbackStorage');
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.proof_img = url
    },
    handleError(err) {
      console.log('====handleError====')
      // 上传失败
      Toast(err);
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/feedback.vue